import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../../core-ui';
import { AddToGroupPillboxComponent } from './AddToGroupPillbox.component';

@NgModule({
    imports: [CommonModule, FormsModule, CoreUiModule],
    declarations: [AddToGroupPillboxComponent],
    exports: [AddToGroupPillboxComponent],
    providers: []
})
export class AddToGroupPillboxModule {}
